
<template>
  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class = "heading" v-if="mode==='create'">Create Load</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode==='update'">Modify Load</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode==='copy'">Copy Load</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode==='delete'">Delete Load</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode==='status'">Change Stauts</md-dialog-title>
      
    

      <md-dialog-content >
        <form id = "top" novalidate @submit.prevent="doSaveUser">
            <!-- <div v-if="mode == 'create' & getPermission.acnit.view">
              <md-card v-if="dataForm.receivingWindows == '185' & getPermission.acnit.view" :class="getValidationRadio('dataForm.scale')">
                <div>CCR Log ID: {{ ccrLog.logId }} </div>
                <md-card-content>
                  <md-radio v-model="dataForm.scale" value="1" @change="onSelect">FSI Scale 1</md-radio>
                  <md-radio v-model="dataForm.scale" value="2" @change="onSelect">FSI Scale 2</md-radio>
                </md-card-content>
              </md-card>

              <md-card v-if="dataForm.receivingWindows == '186' & getPermission.acnit.view" :class="getValidationRadio('dataForm.scale')">
                <div>CCR Log ID: {{ ccrLog.logId }} </div>
                <md-card-content>
                  <md-radio v-model="dataForm.scale" value="3" @change="onSelect">WIL Scale1</md-radio>
                  <md-radio v-model="dataForm.scale" value="4" @change="onSelect">WIL Scale2</md-radio>
                </md-card-content>
              </md-card>
            </div> -->
         

        <div class = "down">

        <div class="layoutPlant"> </div>
   
        <div class = "inputBoxDoubleLoadList">
          <div class = "inputSpace">

            <template v-if="mode != 'delete'">
              <auto-complete-master-data-select
                  label="Rec Window"
                  :prepared-options="recWindows"
                  :init-value-id="dataForm.receivingWindow"
                  :on-item-changed="handleRecWindowChanged"
              />
            </template>
            <template v-else>
              <md-field>
              <label for="receivingWindows">Rec Window</label>
              <md-input name="receivingWindows"
                      id="receivingWindows"
                      autocomplete="new-password"
                      v-model="dataForm.receivingWindows"
                      :disabled="mode=='delete' "
                  />
              </md-field>
            </template>
            <!-- 
            <auto-complete-master-data-select v-if="mode != 'status' && mode != 'delete'" :class="getValidationClass('dataForm.salesOffice')"
                                                group="GST_SALEOFFICE"
                                                label="Sales Office"
                                                :init-value="dataForm.salesOffice"
                                                :disabled=" mode=='delete'"
                                                :on-item-changed="handleSalesOfficeChanged"
                                                >
            </auto-complete-master-data-select>
            <md-field v-if="mode == 'delete'" :class="getValidationClass('dataForm.receivingWindows')">
            <label for="receivingWindows">Rec Window</label>
            <md-input name="receivingWindows"
                      id="receivingWindows"
                      autocomplete="new-password"
                      v-model="dataForm.receivingWindows"
                      :disabled="mode=='delete' "
            />
          </md-field>
        -->
          </div>
            <!--
            <div class = "layout">
            <auto-complete-master-data-select v-if="mode != 'status'" :class="getValidationClass('dataForm.source')"
                                                group="GST_SOURCE"
                                                label="Source"
                                                :init-value="dataForm.source"
                                                :on-item-changed="handleSourceChanged"
                                                 :disabled="mode=='delete' "
                                                >
            </auto-complete-master-data-select>
        </div>
      -->
          <div class = "inputSpace">
             <md-field>
                <label>IBS Type</label>
                <md-input v-model="dataForm.ibsType" :disabled="dataForm.mode == 'DELETE'"/>
              </md-field>
          </div>


          </div>
          

        <div class = "inputBoxDoubleLoadList">
           <div class = "inputSpace">
             <md-field>
                <label>Transloading Yard</label>
                <md-input v-model="dataForm.transloadYard" :disabled="dataForm.mode == 'DELETE'"/>
              </md-field>
          </div>

          <div class = "inputSpace">
            <md-field>
                <label>PO Last Delivery Date</label>
                <md-input v-model="dataForm.poLastDeliveryDate" :disabled="dataForm.mode == 'DELETE'"/>
              </md-field>
          </div>
        </div>


        <div class = "inputBoxDoubleLoadList">
           <div class = "inputSpace">
            <md-field>
                <label>IBS</label>
                <md-input v-model="dataForm.releaseNumber" :disabled="dataForm.mode == 'DELETE'"/>
              </md-field>
          </div>

          <div class = "inputSpace">
            <md-field>
                <label>AC Name</label>
                <md-input v-model="dataForm.acName" :disabled="dataForm.mode == 'DELETE'"/>
              </md-field>

          </div>
        </div>




        <div class = "inputBoxDoubleLoadList">
          <div class = "inputSpace">
            <md-field>
                <label>Material</label>
                <md-input v-model="dataForm.material" :disabled="dataForm.mode == 'DELETE'"/>
              </md-field>

          </div>

          <div class = "inputSpace">
            <md-field>
                <label>Supplier Name</label>
                <md-input v-model="dataForm.supplierName" :disabled="dataForm.mode == 'DELETE'"/>
            </md-field>

          </div>
        </div>


       <div class = "inputBoxDoubleLoadList">
         <div class = "inputSpace">
          <md-field>
                <label>Trucker Name</label>
                <md-input v-model="dataForm.truckName" :disabled="dataForm.mode == 'DELETE'"/>
              </md-field>
            
        </div>


          <div class = "inputSpace">
            <md-field>
                <label>IBD</label>
                <md-input v-model="dataForm.ibd" :disabled="dataForm.mode == 'DELETE'"/>
              </md-field>

          </div>
          </div>


        <div class = "inputBoxDoubleLoadList">
         <div class = "inputSpace">
          <md-field>
                <label>PO Number</label>
                <md-input v-model="dataForm.poNumber" :disabled="dataForm.mode == 'DELETE'"/>
              </md-field>

        </div>
        <div class = "inputSpace">
        </div>
        </div>


        



      </div>

        

        <div class = "alwaysShow">
          <callingApiCenter type="bar" :paths="['/api/w/gst/loadlist/create','/api/w/users','/api/w/gst/loadlist', '/api/w/gst/createyardstage']"></callingApiCenter>
          <div v-if="mode==='create'">
            <md-dialog-actions >
              <md-button class="md-raised custButtonForm " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
              <md-button type="submit" class="md-raised custButtonForm "><span class="icons-center material-icons">create</span>Create</md-button>
            </md-dialog-actions>
          </div>
        

          <div v-if="mode==='update'">
            <md-dialog-actions>
              <md-button class="md-raised custButton" @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
              <md-button type="submit" class="md-raised custButton"><span class="icons-center material-icons">update</span>Save</md-button>
            </md-dialog-actions>
          </div>

        <calling-api v-if="mode==='copy'">
            <md-dialog-actions>
              <md-button class="md-raised custButton" @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
              <md-button type="submit" class="md-raised custButton"><span class="icons-center material-icons">file_copy</span>Copy</md-button>
            </md-dialog-actions>
          </calling-api>


        <calling-api v-if="mode==='delete'">
            <md-dialog-actions>
              <md-button class="md-raised custButton " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
              <md-button type="submit" class=" custButton redButton "><span class="icons-center material-icons">delete</span>Delete</md-button>
            </md-dialog-actions>
          </calling-api>


        <calling-api v-if="mode==='status'">
            <md-dialog-actions>
              <md-button class="md-raised custButton" @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
              <md-button type="submit" class="md-raised custButton"><span class="icons-center material-icons">cancel</span>Save</md-button>
            </md-dialog-actions>
          </calling-api>
        </div>
      </form>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>


.container {
  display: flex;
  flex-direction: row;
  margin: auto;
  width: 300px;
}

.layoutPlant {
  padding-top: 0;
  padding-left: 0;
  padding-bottom: 0;
  width: 20%;
  line-height: 1.5;
  color: black;
  background-color: rgb(185, 218, 237);
  display: inline-block;
  font-family: Roboto Slab;
  margin: auto;
}

.layoutScale {
  padding-top: 0;
  padding-left: 0;
  padding-bottom: 0;
  font-family: Roboto Slab;
  margin: auto;
}

  form {
    min-width: 560px;
    margin: 24px;
  }
  
  .alwaysShow {
    position: fixed;
    right: 60px;
    top : 30px;
  }

  
  .redButton{
    background-color: #c50000;
    z-index: 4;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  }


  .icons-center {
    vertical-align: middle;
    margin-right: 10px;
  }

  .custButtonForm {
    margin: 0px;
    width: 100px;
    height: 30px;
    line-height: 20px;
    font-size: 0.7rem; 
  }

  .heading{
    padding-top: 30px;
    margin-bottom: 0;
    color: #555555;
    width: 92%;
    line-height: 1;
    font-size: 26px;
    font-family: Roboto Slab;
    margin-left: 60px;
  }

  .layout{
    margin-top: 0px;
    margin-bottom: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
    width: 92%;
    line-height: 0;
    color: #555555;
    font-family: Roboto Slab;
    margin: auto;
  }


  .inputBoxDoubleLoadList {
  width: 500px;
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  margin: auto;
}

.inputSpace {
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 200px;
  line-height: 1em;
}

.inputBoxWide {
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 450px;
  line-height: 1em;
}

.inputCheckBoxWide {
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 450px;
  line-height: 1em;
}

.ErrorMessage {
  color: #f14668 !important;
  font-size: 12px;
}

</style>

<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  import AutocompleteSelect from "./AutoCompleteDebounceSelect.vue";
  import callingApiCenter from "./CallingApiCenter.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  import moment from 'moment';

  const getInitialdataForm = () => ({
    receivingWindow: null,
    //ibs_type: null,
    ibsType: null,
    ibsKey: null,
    transloadYard: null,
    //ibs: null,
    releaseNumber: null,
    //po_lsd: null,
    poLastDeliveryDate: null,
    ibs_process_dt: null,
    ibs_process_time: null,
    acName: null,
    ibsStatus: null,
    material: null,
    supplierName: null,
    truckName: null,
    ibd: null,
    poNumber: null,    
    mode: null,

    // salesOffice: null,
    // source: null,
    // transloadingYard: null,
    // receivingWindows: null,
    // ctnrType: null,
    // containerNo: null,
    // oldcontainerNo: null,
    // chassisNo: null,
    // oldchassisNo: null,
    // ownChassis: null,
    // chassisVendor: null,
    // carrier: null,
    // pickupLocation: null,
    // moveInDate: null,
    // moveInDateLocal: null,
    // moveInTime: "00:00:00",
    // chzStartDate: null,
    // oldchzStartDate: null,
    // chzStartDateLocal: null,
    // chzStartTime: "00:00:00",
    // moveInBy: null,
    // loadStatus: "EPT",
    // oldloadStatus: "EPT",
    // scac:null,
    // yard: null,
    // locationNumber: null,
    // poolContract: null,
    // fallbackStart: null,
    // fallbackEnd: null,
    // chzDefault: false,
    // scale: null,
    // deliveryOrder: null,
  });

const getInitSearchRequest = () => ({
  yard: null,
  gateType: "S",
  gateNo: null,
  statusType: null,
  logDateTime: {
    startDate: null,
    endDate: null
  },
  logStatus: null
});

const getInitCcrLog = () => ({
  office: "LGB",
  logId: null,
  yard: null,
  gateType: null,
  gateNo: null,
  statusType: null,
  logDateTime: null,
  plateNo: null,
  plateImage: null,
  containerNo: null,
  containerType: null,
  containerImage: null,
  chassisNo: null,
  chassisImage: null,
  scaleWeight: null,
  processType: null,
  inboundShipment: null,
  seqNo: null,
  date: null,
  time: null,
});

  const getInitChassis = () => ({
    salesOffice: null,
    agreement: null
  });


  export default {
    components: { AutocompleteCcicLocationSelect ,callingApiCenter,AutocompleteSelect},
    mixins: [validationMixin],
    props: {
      mode: String,
      action: Function,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      loadList: [],
      drivers:[],
      timeError: null,
      dispatchers: [],
      ccicQcUsers: [],
      ccrLog: getInitCcrLog(),
      result: getInitCcrLog(),
      searchRequest: getInitSearchRequest(),
      searchRequestChassis: getInitChassis(),
      loadstatuserrormessage: '', 
      notISOContainer: false,
      notFormatContainer: false,
      recWindows: [],
    }),

    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getMasterDataName',
        'getUserProfile',
        'getPermission',
      ]),

      // canChangestatus() {
      //   return this.dataForm.oldloadStatus === 'EPT' && this.dataForm.oldloadStatus === 'LD';
      // },
      
    },


    validations: {
      dataForm: {
          ibsType: {
             required,
          },
        // salesOffice: {
        //   required,
        // },
        // source: {
        //     required,
        // },
        // transloadingYard: {
        //     required,
        // },
        // receivingWindows: {
        //     required,
        // },
        // ctnrType: {
        //     required,
        // },

        

        // containerNo: {
        //     minLength: minLength(11),
        //     maxLength: maxLength(11),
        // },
        // chassisNo: {
        //     required,
        //     minLength: minLength(9),
        //     maxLength: maxLength(15),
        // },
        // moveInDate:{
        //         required,
        // },
        // moveInTime:{
        //     required,
        //     add : (value) => {
              
        //       const res = moment('2021-04-01T' + value).toDate();
        //       return res != 'Invalid Date';
        //     }
        // },
        // chzStartTime:{
        //     add : (value) => {
        //       console.log(value);
        //       if (value == null || value == '') 
        //       {
        //         return true
        //       }
        //       else
        //       {
        //         const res = moment('2021-04-01T' + value).toDate();
        //         return res != 'Invalid Date';
        //       }
              
        //     }
        // },
        // loadStatus:{
        //     required,
        // },

        // ownChassis: {}, 
        // scac: {}, 
        // chassisVendor:{}, 
        // carrier:{}, 
        // pickupLocation:{}, 
        // moveInBy:{}, 
        // yard:{}, 
        // locationNumber:{}, 
        // poolContract: {},
      },
    },


    methods: {
     async openDialog(existingUser) {
        this.$store.commit('clearApiError');
        this.$v.dataForm.$reset();
        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();
        this.ccrLog = getInitCcrLog();
        //this.dataForm.chzDefault = false;
        //this.dataForm.username = this.getUserProfile.username;
        //this.dataForm.transloadingYard = '1010001';

        console.log("existinguser: " + JSON.stringify(existingUser));

        this.recWindows = this.getMasterDataAsSelectOptionByGroup('REC_WINDOW');
        if (this.recWindows.length == 0)
        {
            //this.recWindows = await api.post('/api/w/masterData',
            this.recWindows = await newAPIPost('/api/w/masterData',
               {groups: 'REC_WINDOWS'  }
            );    
        }
        this.recWindows = _(this.recWindows).filter(it => it.extTrucker == '3RDPARTY');


        if (existingUser && this.mode === 'create' ) {
          // this.dataForm.salesOffice = existingUser.salesOffice;
          // this.dataForm.receivingWindows = existingUser.receivingWindows;    
          // this.dataForm.deliveryOrder = existingUser.deliveryOrder;
          this.dataForm.transloadYard = "1010001";
        }

        if (existingUser && this.mode === 'update' ) {
          
          this.dataForm.receivingWindow = existingUser.receivingWindows;
          this.dataForm.ibsType = existingUser.ibs_type;
          this.dataForm.ibsKey = existingUser.ibsKey;
          this.dataForm.transloadYard = existingUser.trans_yard;
          this.dataForm.releaseNumber = existingUser.ibs;
          this.dataForm.poLastDeliveryDate = existingUser.po_lsd;
          this.dataForm.ibs_process_dt = existingUser.ibs_process_DT;
          this.dataForm.ibs_process_time = existingUser.ibs_process_TIME;
          this.dataForm.acName = existingUser.ac_name;
          this.dataForm.ibsStatus = existingUser.ibs_status;
          this.dataForm.material = existingUser.matnr;
          this.dataForm.supplierName = existingUser.supplier_name;
          this.dataForm.truckName = existingUser.trucker_name;
          this.dataForm.ibd = existingUser.ibd;
          this.dataForm.poNumber = existingUser.po;
          this.dataForm.mode = "UPDATE";
        }


        if (existingUser && this.mode === 'status') {
          this.loadList = existingUser;
        }




        if (existingUser && this.mode === 'copy') {
          this.dataForm.receivingWindow = existingUser.receivingWindows;
          this.dataForm.ibsType = existingUser.ibs_type;
          this.dataForm.transloadYard = existingUser.trans_yard;
          this.dataForm.releaseNumber = existingUser.ibs;
          this.dataForm.poLastDeliveryDate = existingUser.po_lsd;
          this.dataForm.ibs_process_dt = existingUser.ibs_process_DT;
          this.dataForm.ibs_process_time = existingUser.ibs_process_TIME;
          this.dataForm.acName = existingUser.ac_name;
          this.dataForm.ibsStatus = existingUser.ibs_status;
          this.dataForm.material = existingUser.matnr;
          this.dataForm.supplierName = existingUser.supplier_name;
          this.dataForm.truckName = existingUser.trucker_name;
          this.dataForm.ibd = existingUser.ibd;
          this.dataForm.poNumber = existingUser.po;
          this.dataForm.mode = "COPY";
        }


        if (existingUser && this.mode === 'delete') {
          this.dataForm.receivingWindow = existingUser.receivingWindows;
          this.dataForm.ibsType = existingUser.ibs_type;
          this.dataForm.ibsKey = existingUser.ibsKey;
          this.dataForm.transloadYard = existingUser.trans_yard;
          this.dataForm.releaseNumber = existingUser.ibs;
          this.dataForm.poLastDeliveryDate = existingUser.po_lsd;
          this.dataForm.ibs_process_dt = existingUser.ibs_process_DT;
          this.dataForm.ibs_process_time = existingUser.ibs_process_TIME;
          this.dataForm.acName = existingUser.ac_name;
          this.dataForm.ibsStatus = existingUser.ibs_status;
          this.dataForm.material = existingUser.matnr;
          this.dataForm.supplierName = existingUser.supplier_name;
          this.dataForm.truckName = existingUser.trucker_name;
          this.dataForm.ibd = existingUser.ibd;
          this.dataForm.poNumber = existingUser.po;
          this.dataForm.mode = "DELETE";
        }

        this.notISOContainer = false;
        this.notFormatContainer = false;
        this.showDialog = true;
        // this.drivers = [];
        // await this.$store.dispatch('getUsersByCategory', { category: 'L' })
        // .then((res) => {
        //   this.drivers = res;
        // });
      },

      handleCustIDChanged(id, name){
          console.log(`handleCustIDChanged`, id, name);
        this.dataForm.locationNumber = id;
      },

    onSelect() {
      console.log("CCR Create Container");
      this.readAction();
    },

    handleRecWindowChanged(id) {
      this.dataForm.receivingWindow = id;
      console.log("rec win: " + this.dataForm.receivingWindow + ", id: " + id);
    },

    getValidationRadio(fieldName) {
      const field = _(this.$v).lookup(fieldName);

      if (field) {
        return {
          ErrorMessage: field.$invalid && field.$dirty,
        };
      }
      return {};
    },

    getActiveCarrir() {
       const carrier = this.getMasterDataAsSelectOptionByGroup('STC_CARRIER');
       //console.log("active carrier: " + JSON.stringify(carrier));
       return carrier;
    },

    readAction() {
      this.getCCRLog(this.dataForm);
    },

    async getCCRLog(LogCcr) {
      this.ccrLog = getInitCcrLog();
      this.result = getInitCcrLog();

      if (LogCcr == null) return;
      const scaleDate = dateFormat.getLocalDateOnly(moment().toDate())
      this.searchRequest.yard = LogCcr.yard;
      this.searchRequest.statusType = "S";
      this.searchRequest.gateNo = LogCcr.scale; 
      this.searchRequest.logDateTime.startDate = scaleDate + "T00:00:01";
      this.searchRequest.logDateTime.endDate = scaleDate + "T23:59:59";

      const search = this.searchRequest;

      if (LogCcr.scale != null)
      {
        //this.result = await api.post('/api/w/ccr/data/getCCRLog', search);
        this.result = await newAPIPost('/api/w/ccr/data/getCCRLog', search);
        this.result.sort((a,b) => new Date(b.logDateTime) - new Date(a.logDateTime));
        this.ccrLog = this.result[0];
        this.dataForm.containerNo = this.ccrLog.containerNo;
        this.dataForm.ctnrType = this.ccrLog.containerType;
        this.dataForm.chassisNo = this.ccrLog.chassisNo;
        this.dataForm.moveInDate = moment(String(this.ccrLog.logDateTime)).format('MM/DD/YYYY');
        this.dataForm.moveInTime = moment(String(this.ccrLog.logDateTime)).format('hh:mm:ss');
 
      };
    },



      handlePickLocationChanged(item) {
        if (item) {
          this.dataForm.pickupLocation = item.tagId;
        } else {
          this.dataForm.pickupLocation = null;
        }
      },

      handleWindowsChanged(id) {
        this.dataForm.receivingWindows = id;
    },


    handleCtnrTypeChanged(id) {
      this.dataForm.ctnrType = id;
    },


       handleSalesOfficeChanged(id) {
        this.dataForm.salesOffice = id;
      },

      handleSourceChanged(id) {
        this.dataForm.source = id;
      },

      handleChassisVendorChanged(id) {
        this.dataForm.chassisVendor = id;
      },



      //handleCarrierChanged({id,tagName}) {
      handleCarrierChanged(id) {
        //console.log("carrier id: " + id);
        const selectedCarrier = this.getActiveCarrir().filter(it => it.tagId == id);
        var tagname = null;
        if (selectedCarrier && selectedCarrier.length > 0) {
           tagname = selectedCarrier[0].tagName
        }
        //console.log("all carriers: " + JSON.stringify(tagname));
        this.dataForm.carrier = tagname;
        this.dataForm.scac = id;
      },


      // handleChassisChanged({id,tagName}) {
      //   console.log(id);
      //   console.log(tagName);
      //   // this.dataForm.chassisNo = tagName;
      //   if (tagName != null )
      //   {
      //     this.dataForm.ownChassis = "YES";
      //     this.dataForm.chassisVendor = tagName;
      //   }

      //   if (tagName == null )
      //   {
      //     this.dataForm.ownChassis = " ";
      //     this.dataForm.chassisVendor = " ";
      //   }

      // },

       handleScacChanged(id) {
        //this.dataForm.scac = id;
      },


      handleDriverChanged(id) {
        this.dataForm.moveInBy = id;
      },

      async checkISO() {
        this.notISOContainer = false;
        this.notFormatContainer = false;
        const containerRegex = /^[A-Z]{4}[0-9]{7}/;
        //console.log("containerNo: " + this.dataForm.containerNo);
        if (this.dataForm.containerNo && this.dataForm.containerNo != "" 
           && this.dataForm.containerNo.length == 11) {
            //alert("check container#: " + this.dataForm.containerNo);
            if (!containerRegex.test(this.dataForm.containerNo.toUpperCase())) {
               this.notFormatContainer = true;
               return;
            }
            const org_checkdigit = this.dataForm.containerNo.slice(10,11);
            var checkdigit = "";
            //await api.post("/api/w/GetContainerISOCheckDigit", {containerNo: this.dataForm.containerNo})
            await newAPIPost("/api/w/GetContainerISOCheckDigit", {containerNo: this.dataForm.containerNo})
                    .then((retVal) =>{
                        //console.log("retVal: " + JSON.stringify(retVal));
                        checkdigit = retVal
                    })
            //console.log("checkdigit: " + checkdigit);
            if (org_checkdigit != checkdigit)
                this.notISOContainer = true;  
           } else if (this.dataForm.containerNo.length > 11) {
                this.notFormatContainer = true;
           }  
      },
      
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },

      handleStatusChanged(id, name) {
        console.log(`handleStatusChanged`, id, name);
        this.dataForm.loadStatus = id;
        //this.dataForm.loadStatus = name;
      },

     cancalAction(){
        this.showDialog = false;
         this.$store.commit('clearApiError');
     },


      doSaveUser() {
        this.timeError = null;
        this.$v.dataForm.$touch();
        this.dataForm.fallbackStart = moment().subtract(1,'months').startOf('d').toDate();
        this.dataForm.fallbackEnd = moment().endOf('d').toDate();
        
        if (this.mode=='create' || this.mode=='copy')
        {
            this.dataForm.action = "CREATE";
        }

         if (this.mode=='update')
        {
          //if (this.dataForm.oldloadStatus !=  this.dataForm.loadStatus &&  ( this.dataForm.loadStatus == 'BLC' || this.dataForm.loadStatus == 'CFM' || this.dataForm.loadStatus == 'LOK') && this.dataForm.source !== 'D')
          //{
          //  this.loadstatuserrormessage = 'Load status can not manually change to : ' +  this.dataForm.loadStatus ; 
          //  window.confirm(this.loadstatuserrormessage)
          //  return;
          //}
          
          //if (this.dataForm.oldcontainerNo != this.dataForm.containerNo || this.dataForm.oldchassisNo != this.dataForm.chassisNo || this.dataForm.oldchzStartDate != this.dataForm.chzStartDate || this.dataForm.oldloadStatus != this.dataForm.loadStatus)
          //  {
          //    console.log(`Container data changelog old`, this.dataForm.oldcontainerNo ,this.dataForm.oldchassisNo , this.dataForm.oldchzStartDate ,this.dataForm.oldloadStatus);
          //    console.log(`Container data changelog new`, this.dataForm.containerNo ,this.dataForm.chassisNo , this.dataForm.chzStartDate ,this.dataForm.loadStatus);
          //  }

          
            this.dataForm.mode = "UPDATE";
        }


        if (this.mode=='delete')
        {
            this.dataForm.mode = "DELETE";
        }




        // this.searchRequestChassis.salesOffice = this.dataForm.salesOffice;
        // this.searchRequestChassis.agreement = this.dataForm.agreement;
        // if (this.searchRequestChassis.agreement != null){
        //   const agrementResult = await api.post('/api/w/gst/gstpriceagreement/search', this.searchRequest)
        //     if ( agrementResult.length < 1 ){
        //       window.confirm('Rate Agreement number ' + this.dataForm.agreement + ' not found!')
        //         return;
        //     };
        // }

       //console.log("to save carrier: " + this.dataForm.carrier);



       //this.dataForm.salesOffice = this.dataForm.salesOffice == null ? this.dataForm.salesOffice : this.dataForm.salesOffice.toUpperCase();
       //this.dataForm.source = this.dataForm.source == null ? this.dataForm.source : this.dataForm.source.toUpperCase();
       //this.dataForm.containerNo = this.dataForm.containerNo == null ? this.dataForm.containerNo : this.dataForm.containerNo.toUpperCase();    
       //this.dataForm.chassisNo = this.dataForm.chassisNo == null ? this.dataForm.chassisNo : this.dataForm.chassisNo.toUpperCase();
       //this.dataForm.scac = this.dataForm.scac == null ? this.dataForm.scac : this.dataForm.scac.toUpperCase();
       //this.dataForm.chassisVendor = this.dataForm.chassisVendor == null ? this.dataForm.chassisVendor : this.dataForm.chassisVendor.toUpperCase();
       //this.dataForm.carrier = this.dataForm.scac == null ? this.dataForm.scac : this.dataForm.scac.toUpperCase();
       //this.dataForm.pickupLocation = this.dataForm.pickupLocation == null ? this.dataForm.pickupLocation : this.dataForm.pickupLocation.toUpperCase();
       //this.dataForm.moveInBy = this.dataForm.moveInBy == null ? this.dataForm.moveInBy : this.dataForm.moveInBy.toUpperCase();
       //this.dataForm.yard = this.dataForm.yard == null ? this.dataForm.yard : this.dataForm.yard.toUpperCase();
       //this.dataForm.locationNumber = this.dataForm.locationNumber == null ? this.dataForm.locationNumber : this.dataForm.locationNumber.toUpperCase();

        console.log(`doSaveUser , invalid=${this.$v.dataForm.$invalid}`);
        // console.log(`Form data is ${JSON.stringify(this.dataForm)}`);

        if (this.$v.dataForm.$invalid) {
        //  this.$refs.top.$el.focus();
          return;
        }
        
        // const timeRef = moment('2021-04-01T' + this.dataForm.moveInTime).format('HH:mm:ss');
        // this.dataForm.moveInDate = dateFormat.getLocalDateOnly(this.dataForm.moveInDate) + 'T' + timeRef;

        // if (this.dataForm.chzStartDate == null || this.dataForm.chzStartDate == '')
        // {
        //   this.dataForm.chzDefault = true
        // }
        // else
        // {
        //   if (this.dataForm.chzStartTime == null || this.dataForm.chzStartTime == '')
        //   {
        //     const timeRefChassis = moment('2021-04-01T' + this.dataForm.moveInTime).format('HH:mm:ss');
        //     this.dataForm.chzStartDate = dateFormat.getLocalDateOnly(this.dataForm.chzStartDate) + 'T' + timeRefChassis;
        //   }
        //   else
        //   {
        //     const timeRefChassis = moment('2021-04-01T' + this.dataForm.chzStartTime).format('HH:mm:ss');
        //     this.dataForm.chzStartDate = dateFormat.getLocalDateOnly(this.dataForm.chzStartDate) + 'T' + timeRefChassis;
        //   }
        // }


        // console.log(`Form data is ${JSON.stringify(this.dataForm)}`);
      
        //api.post("/api/w/fsi/WebUploadNonfsiibs", this.dataForm)
        newAPIPost("/api/w/fsi/WebUploadNonfsiibs", this.dataForm)
          .then((item) => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            // $('.btn-search-loadlist-container')
            //   .click();
             this.action(item.loadKey || item.seqNo, this.mode);
          });
      },
    },
  };
</script>
